export const getByPath = (object: any, path: string) => {
  if (!path) {
    return;
  }

  return path.split('.')
    .reduce((acc, value) => acc[value], object);
};
